module.exports = {"371471007":"长河街道","371471008":"宋官屯街道","371471106":"赵虎镇","371471107":"抬头寺镇","371471108":"袁桥镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371471.json
// module id = 1481
// module chunks = 0